// src/pages/Dashboard.tsx
import React from "react";

const Dashboard: React.FC = () => {
  return (
    <div className="main-content">
      Welcome to the Dashboard
    </div>
  );
};

export default Dashboard;
